import React, { Component, type ReactNode } from 'react';

interface Props {
  children: ReactNode;
  fallback?: ReactNode;
}

interface State {
  hasError: boolean;
  error?: Error;
}

export class ErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    console.error('ErrorBoundary caught an error:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      if (this.props.fallback) {
        return this.props.fallback;
      }

      return (
        <div className="flex min-h-screen flex-col items-center justify-center bg-slate-50 px-6 text-center">
          <h1 className="text-2xl font-semibold text-slate-800">Algo deu errado</h1>
          <p className="mt-4 max-w-lg text-sm text-slate-500">
            Ocorreu um erro ao carregar a aplicação. Por favor, recarregue a página.
          </p>
          {this.state.error && (
            <details className="mt-4 max-w-lg text-left">
              <summary className="cursor-pointer text-sm text-slate-600">Detalhes do erro</summary>
              <pre className="mt-2 overflow-auto rounded bg-slate-100 p-2 text-xs text-slate-800">
                {this.state.error.toString()}
              </pre>
            </details>
          )}
          <button
            className="mt-6 inline-flex items-center rounded-full bg-primary-600 px-5 py-2 text-sm font-medium text-white shadow hover:bg-primary-700"
            onClick={() => window.location.reload()}
          >
            Recarregar página
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}

